module.exports = __webpack_public_path__ + "img/code2.a3782d09.png";